import { ReactNode } from 'react';

interface IconWrapperProps {
  children: ReactNode;
  className?: string;
}

export const IconWrapper = ({ children, className }: IconWrapperProps) => {
  return <span className={className}>{children}</span>;
};
